import forEach from 'lodash/forEach';
import has from 'lodash/has';

function composeAnnotations(annotationRules, sa) {
  if (has(annotationRules, '__description')) {
    sa.setAttributeDescription(annotationRules.__name, annotationRules.__description);
  }

  if (has(annotationRules, '__format')) {
    sa.setAttributeFormat(annotationRules.__name, annotationRules.__format);
  }

  return sa;
}

function composeAnnotationsForRule(rule, sa) {
  if (has(rule, '__description')) {
    sa.setAttributeDescription(rule.__name, rule.__description);
  }

  if (has(rule, '__format')) {
    sa.setAttributeFormat(rule.__name, rule.__format);
  }

  return sa;
}

function batchComposeAnnotations(rulesArray, sa) {
  let { items, orderByAttrId } = rulesArray;
  forEach(orderByAttrId, (attrId, idx) => {
    let thisRule = items[attrId];
    sa = composeAnnotationsForRule(thisRule, sa);
  });
  return sa;
}

function batchExtractAnnotations(attrsArray) {
  let items = {},
    orderByAttrId = [];

  forEach(attrsArray, (attr, idx) => {
    items = {
      ...items,
      [attr.__name]: {
        __name: attr.__name,
        __description: attr.__description,
        __format: attr.__format,
      },
    };
    orderByAttrId = [...orderByAttrId, attr.__name];
  });
  return { items, orderByAttrId };
}

var SchemaAnnotationUtils = {
  composeAnnotations,
  composeAnnotationsForRule,
  batchComposeAnnotations,
  batchExtractAnnotations,
};

export default SchemaAnnotationUtils;
